module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "dialer-manual-flow-form-modal",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('flows.reports.label.title')))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('label', {
    staticClass: "fix"
  }, [_vm._v(_vm._s(_vm.$t('flows.reports.label.periodLabel')))]), _c('dropdown-select', {
    attrs: {
      "options": _vm.optionsList,
      "capital": true,
      "verify": true
    },
    on: {
      "input": _vm.filter
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row config"
  }, [_c('div', {
    staticClass: "col-sm"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "defaultCheck1"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMark()
      }
    }
  }), _vm._v("  " + _vm._s(_vm.$t('flows.reports.label.addContact')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "2",
      "id": "defaultCheck2"
    },
    on: {
      "click": function($event) {
        return _vm.toggleactivated_contactsMark()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('flows.reports.label.activatedContacts')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "3",
      "id": "defaultCheck3"
    },
    on: {
      "click": function($event) {
        return _vm.toggleactive_contactMark()
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('flows.reports.label.activeContact')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm extra_fix"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "6",
      "id": "defaultCheck6"
    },
    on: {
      "click": function($event) {
        return _vm.togglelostContactMark()
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('flows.reports.label.lostContact')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "4",
      "id": "defaultCheck4"
    },
    on: {
      "click": function($event) {
        return _vm.toggleconnected_contact()
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('flows.reports.label.connectedContact')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "7",
      "id": "defaultCheck7"
    },
    on: {
      "click": function($event) {
        return _vm.toggletasksRealizedMark()
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('flows.reports.label.tasksRealized')) + " ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('flows.reports.label.canceled')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": false,
      "type": "button"
    },
    on: {
      "click": _vm.sending
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('flows.reports.label.generate')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46827e1e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/modal_flow.vue
// module id = 1097
// module chunks = 1